function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CoordinateSequenceFactory from './CoordinateSequenceFactory';
import LineString from './LineString';
import Geometry from './Geometry';
import hasInterface from '../../../../hasInterface';
import Coordinate from './Coordinate';
import Point from './Point';
import Polygon from './Polygon';
import MultiPoint from './MultiPoint';
import GeometryEditor from './util/GeometryEditor';
import LinearRing from './LinearRing';
import CoordinateArraySequenceFactory from './impl/CoordinateArraySequenceFactory';
import MultiPolygon from './MultiPolygon';
import CoordinateSequences from './CoordinateSequences';
import CoordinateSequence from './CoordinateSequence';
import GeometryCollection from './GeometryCollection';
import PrecisionModel from './PrecisionModel';
import Serializable from '../../../../java/io/Serializable';
import Assert from '../util/Assert';
import MultiLineString from './MultiLineString';
var GeometryFactory = /*#__PURE__*/function () {
  function GeometryFactory() {
    _classCallCheck(this, GeometryFactory);
    GeometryFactory.constructor_.apply(this, arguments);
  }
  return _createClass(GeometryFactory, [{
    key: "toGeometry",
    value: function toGeometry(envelope) {
      if (envelope.isNull()) {
        return this.createPoint();
      }
      if (envelope.getMinX() === envelope.getMaxX() && envelope.getMinY() === envelope.getMaxY()) {
        return this.createPoint(new Coordinate(envelope.getMinX(), envelope.getMinY()));
      }
      if (envelope.getMinX() === envelope.getMaxX() || envelope.getMinY() === envelope.getMaxY()) {
        return this.createLineString([new Coordinate(envelope.getMinX(), envelope.getMinY()), new Coordinate(envelope.getMaxX(), envelope.getMaxY())]);
      }
      return this.createPolygon(this.createLinearRing([new Coordinate(envelope.getMinX(), envelope.getMinY()), new Coordinate(envelope.getMinX(), envelope.getMaxY()), new Coordinate(envelope.getMaxX(), envelope.getMaxY()), new Coordinate(envelope.getMaxX(), envelope.getMinY()), new Coordinate(envelope.getMinX(), envelope.getMinY())]), null);
    }
  }, {
    key: "createLineString",
    value: function createLineString() {
      if (arguments.length === 0) {
        return this.createLineString(this.getCoordinateSequenceFactory().create([]));
      } else if (arguments.length === 1) {
        if (arguments[0] instanceof Array) {
          var coordinates = arguments[0];
          return this.createLineString(coordinates !== null ? this.getCoordinateSequenceFactory().create(coordinates) : null);
        } else if (hasInterface(arguments[0], CoordinateSequence)) {
          var _coordinates = arguments[0];
          return new LineString(_coordinates, this);
        }
      }
    }
  }, {
    key: "createMultiLineString",
    value: function createMultiLineString() {
      if (arguments.length === 0) {
        return new MultiLineString(null, this);
      } else if (arguments.length === 1) {
        var lineStrings = arguments[0];
        return new MultiLineString(lineStrings, this);
      }
    }
  }, {
    key: "buildGeometry",
    value: function buildGeometry(geomList) {
      var geomClass = null;
      var isHeterogeneous = false;
      var hasGeometryCollection = false;
      for (var i = geomList.iterator(); i.hasNext();) {
        var geom = i.next();
        var partClass = geom.getClass();
        if (geomClass === null) {
          geomClass = partClass;
        }
        if (partClass !== geomClass) {
          isHeterogeneous = true;
        }
        if (geom instanceof GeometryCollection) hasGeometryCollection = true;
      }
      if (geomClass === null) {
        return this.createGeometryCollection();
      }
      if (isHeterogeneous || hasGeometryCollection) {
        return this.createGeometryCollection(GeometryFactory.toGeometryArray(geomList));
      }
      var geom0 = geomList.iterator().next();
      var isCollection = geomList.size() > 1;
      if (isCollection) {
        if (geom0 instanceof Polygon) {
          return this.createMultiPolygon(GeometryFactory.toPolygonArray(geomList));
        } else if (geom0 instanceof LineString) {
          return this.createMultiLineString(GeometryFactory.toLineStringArray(geomList));
        } else if (geom0 instanceof Point) {
          return this.createMultiPoint(GeometryFactory.toPointArray(geomList));
        }
        Assert.shouldNeverReachHere('Unhandled class: ' + geom0.getClass().getName());
      }
      return geom0;
    }
  }, {
    key: "createMultiPointFromCoords",
    value: function createMultiPointFromCoords(coordinates) {
      return this.createMultiPoint(coordinates !== null ? this.getCoordinateSequenceFactory().create(coordinates) : null);
    }
  }, {
    key: "createPoint",
    value: function createPoint() {
      if (arguments.length === 0) {
        return this.createPoint(this.getCoordinateSequenceFactory().create([]));
      } else if (arguments.length === 1) {
        if (arguments[0] instanceof Coordinate) {
          var coordinate = arguments[0];
          return this.createPoint(coordinate !== null ? this.getCoordinateSequenceFactory().create([coordinate]) : null);
        } else if (hasInterface(arguments[0], CoordinateSequence)) {
          var coordinates = arguments[0];
          return new Point(coordinates, this);
        }
      }
    }
  }, {
    key: "getCoordinateSequenceFactory",
    value: function getCoordinateSequenceFactory() {
      return this._coordinateSequenceFactory;
    }
  }, {
    key: "createPolygon",
    value: function createPolygon() {
      if (arguments.length === 0) {
        return this.createPolygon(null, null);
      } else if (arguments.length === 1) {
        if (hasInterface(arguments[0], CoordinateSequence)) {
          var shell = arguments[0];
          return this.createPolygon(this.createLinearRing(shell));
        } else if (arguments[0] instanceof Array) {
          var _shell = arguments[0];
          return this.createPolygon(this.createLinearRing(_shell));
        } else if (arguments[0] instanceof LinearRing) {
          var _shell2 = arguments[0];
          return this.createPolygon(_shell2, null);
        }
      } else if (arguments.length === 2) {
        var _shell3 = arguments[0];
        var holes = arguments[1];
        return new Polygon(_shell3, holes, this);
      }
    }
  }, {
    key: "getSRID",
    value: function getSRID() {
      return this._SRID;
    }
  }, {
    key: "createGeometryCollection",
    value: function createGeometryCollection() {
      if (arguments.length === 0) {
        return new GeometryCollection(null, this);
      } else if (arguments.length === 1) {
        var geometries = arguments[0];
        return new GeometryCollection(geometries, this);
      }
    }
  }, {
    key: "createGeometry",
    value: function createGeometry(g) {
      var editor = new GeometryEditor(this);
      return editor.edit(g, new CloneOp(this._coordinateSequenceFactory));
    }
  }, {
    key: "getPrecisionModel",
    value: function getPrecisionModel() {
      return this._precisionModel;
    }
  }, {
    key: "createLinearRing",
    value: function createLinearRing() {
      if (arguments.length === 0) {
        return this.createLinearRing(this.getCoordinateSequenceFactory().create([]));
      } else if (arguments.length === 1) {
        if (arguments[0] instanceof Array) {
          var coordinates = arguments[0];
          return this.createLinearRing(coordinates !== null ? this.getCoordinateSequenceFactory().create(coordinates) : null);
        } else if (hasInterface(arguments[0], CoordinateSequence)) {
          var _coordinates2 = arguments[0];
          return new LinearRing(_coordinates2, this);
        }
      }
    }
  }, {
    key: "createMultiPolygon",
    value: function createMultiPolygon() {
      if (arguments.length === 0) {
        return new MultiPolygon(null, this);
      } else if (arguments.length === 1) {
        var polygons = arguments[0];
        return new MultiPolygon(polygons, this);
      }
    }
  }, {
    key: "createMultiPoint",
    value: function createMultiPoint() {
      if (arguments.length === 0) {
        return new MultiPoint(null, this);
      } else if (arguments.length === 1) {
        if (arguments[0] instanceof Array) {
          var point = arguments[0];
          return new MultiPoint(point, this);
        } else if (hasInterface(arguments[0], CoordinateSequence)) {
          var coordinates = arguments[0];
          if (coordinates === null) {
            return this.createMultiPoint(new Array(0).fill(null));
          }
          var points = new Array(coordinates.size()).fill(null);
          for (var i = 0; i < coordinates.size(); i++) {
            var ptSeq = this.getCoordinateSequenceFactory().create(1, coordinates.getDimension());
            CoordinateSequences.copy(coordinates, i, ptSeq, 0, 1);
            points[i] = this.createPoint(ptSeq);
          }
          return this.createMultiPoint(points);
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return GeometryFactory;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Serializable];
    }
  }], [{
    key: "toMultiPolygonArray",
    value: function toMultiPolygonArray(multiPolygons) {
      var multiPolygonArray = new Array(multiPolygons.size()).fill(null);
      return multiPolygons.toArray(multiPolygonArray);
    }
  }, {
    key: "toGeometryArray",
    value: function toGeometryArray(geometries) {
      if (geometries === null) return null;
      var geometryArray = new Array(geometries.size()).fill(null);
      return geometries.toArray(geometryArray);
    }
  }, {
    key: "getDefaultCoordinateSequenceFactory",
    value: function getDefaultCoordinateSequenceFactory() {
      return CoordinateArraySequenceFactory.instance();
    }
  }, {
    key: "toMultiLineStringArray",
    value: function toMultiLineStringArray(multiLineStrings) {
      var multiLineStringArray = new Array(multiLineStrings.size()).fill(null);
      return multiLineStrings.toArray(multiLineStringArray);
    }
  }, {
    key: "toLineStringArray",
    value: function toLineStringArray(lineStrings) {
      var lineStringArray = new Array(lineStrings.size()).fill(null);
      return lineStrings.toArray(lineStringArray);
    }
  }, {
    key: "toMultiPointArray",
    value: function toMultiPointArray(multiPoints) {
      var multiPointArray = new Array(multiPoints.size()).fill(null);
      return multiPoints.toArray(multiPointArray);
    }
  }, {
    key: "toLinearRingArray",
    value: function toLinearRingArray(linearRings) {
      var linearRingArray = new Array(linearRings.size()).fill(null);
      return linearRings.toArray(linearRingArray);
    }
  }, {
    key: "toPointArray",
    value: function toPointArray(points) {
      var pointArray = new Array(points.size()).fill(null);
      return points.toArray(pointArray);
    }
  }, {
    key: "toPolygonArray",
    value: function toPolygonArray(polygons) {
      var polygonArray = new Array(polygons.size()).fill(null);
      return polygons.toArray(polygonArray);
    }
  }, {
    key: "createPointFromInternalCoord",
    value: function createPointFromInternalCoord(coord, exemplar) {
      exemplar.getPrecisionModel().makePrecise(coord);
      return exemplar.getFactory().createPoint(coord);
    }
  }]);
}();
export { GeometryFactory as default };
var CloneOp = /*#__PURE__*/function (_GeometryEditor$Coord) {
  function CloneOp() {
    var _this;
    _classCallCheck(this, CloneOp);
    _this = _callSuper(this, CloneOp);
    CloneOp.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(CloneOp, _GeometryEditor$Coord);
  return _createClass(CloneOp, [{
    key: "edit",
    value: function edit() {
      if (arguments.length === 2 && arguments[1] instanceof Geometry && hasInterface(arguments[0], CoordinateSequence)) {
        var coordSeq = arguments[0];
        var geometry = arguments[1];
        return this.coordinateSequenceFactory.create(coordSeq);
      } else return _superPropGet(CloneOp, "edit", this, 1).apply(this, arguments);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return CloneOp;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}(GeometryEditor.CoordinateSequenceOperation);
CloneOp.constructor_ = function () {
  this.coordinateSequenceFactory = null;
  var coordinateSequenceFactory = arguments[0];
  this.coordinateSequenceFactory = coordinateSequenceFactory;
};
GeometryFactory.CloneOp = CloneOp;
GeometryFactory.constructor_ = function () {
  this._precisionModel = null;
  this._coordinateSequenceFactory = null;
  this._SRID = null;
  if (arguments.length === 0) {
    GeometryFactory.constructor_.call(this, new PrecisionModel(), 0);
  } else if (arguments.length === 1) {
    if (hasInterface(arguments[0], CoordinateSequenceFactory)) {
      var coordinateSequenceFactory = arguments[0];
      GeometryFactory.constructor_.call(this, new PrecisionModel(), 0, coordinateSequenceFactory);
    } else if (arguments[0] instanceof PrecisionModel) {
      var precisionModel = arguments[0];
      GeometryFactory.constructor_.call(this, precisionModel, 0, GeometryFactory.getDefaultCoordinateSequenceFactory());
    }
  } else if (arguments.length === 2) {
    var _precisionModel = arguments[0];
    var SRID = arguments[1];
    GeometryFactory.constructor_.call(this, _precisionModel, SRID, GeometryFactory.getDefaultCoordinateSequenceFactory());
  } else if (arguments.length === 3) {
    var _precisionModel2 = arguments[0];
    var _SRID = arguments[1];
    var _coordinateSequenceFactory = arguments[2];
    this._precisionModel = _precisionModel2;
    this._coordinateSequenceFactory = _coordinateSequenceFactory;
    this._SRID = _SRID;
  }
};
GeometryFactory.serialVersionUID = -6820524753094095635;